// 系统版本号 SSOT — 用户可见, 显示在顶栏「版本 Tag」。
//
// 每次发布系统更新 / 修复 bug 时, 在此更新版本号。语义化版本 (semver): 主.次.修订。
// 后续接入「系统变更说明」页 (changelog) 时, 以此为最新版本锚点。
//
// 注意: 与 web/package.json 的 version 字段保持一致 (人工同步)。
export const APP_VERSION = '0.1.1'

// 顶栏 Tag 显示文案 (带 v 前缀)。
export const APP_VERSION_LABEL = `v${APP_VERSION}`
